import { Token } from './token'
import { Wei } from '../../utils/types'
import { Pool } from '../pools/Pool'
import { floorWei, fromWei } from '../../utils/static-web3'
import { PriceOracle } from '../../api/oracle/oracle-client'
import { TokenWithData } from '../../api/api-types'

export class Amounts extends Map<Token, Wei> {
  constructor() {
    super()
  }

  add(token: Token, amount: Wei): this {
    this.set(token, amount)
    return this
  }

  static fromMap(map: Map<Token, Wei | undefined>): Amounts {
    const m = new Amounts()

    for (const [token, amount] of map.entries()) {
      if (amount) {
        m.set(token, amount)
      }
    }

    return m
  }

  static fromArray(pool: Pool, amounts: Wei[]): Amounts {
    if (pool.tokens.length !== amounts.length) {
      throw 'illegal amounts length for the pool'
    }
    const map = new Amounts()
    pool.tokens.forEach((t, i) => map.set(t, amounts[i]))

    return map
  }

  /**
   * Array.from(this.values()) is not order safe !
   * We use longer but safer code
   */
  toArray(): Wei[] {
    const array: Wei[] = []

    for (const t of this.keys()) {
      array.push(this.get(t)!)
    }
    return array
  }

  toObject(): Record<string, Wei> {
    const obj: Record<string, Wei> = {}
    for (const [token, amount] of this.entries()) {
      obj[token.symbol] = amount
    }
    return obj
  }
  toAnalyticObject(): Record<string, number> {
    const obj: Record<string, number> = {}
    for (const [token, amount] of this.entries()) {
      obj[token.symbol] = fromWei(amount, token.decimals)
    }
    return obj
  }

  map(f: (token: Token, amount: Wei, index?: number) => Wei): Amounts {
    const map = new Amounts()
    let i = 0
    for (const [token, amount] of Array.from(this)) {
      map.set(token, f(token, amount, i))
      i++
    }
    return map
  }

  /**
   * With great power comes great responsibilities : be sure the token is present !
   */
  get(key: Token): Wei {
    return super.get(key)!
  }

  dollarValue(oracle: PriceOracle): number {
    const tokens = Array.from(this.keys())
    const keys = Array.from(this.keys()).map(t => t.symbol)
    const values: number[] = this.toArray().map(
      (v, i) => oracle.getPrice(keys[i]) * fromWei(v, tokens[i].decimals)
    )
    return values.reduce((a, b) => a + b, 0)
  }

  toStringDollar(oracle: PriceOracle) {
    const tokens = Array.from(this.keys())
    const keys = Array.from(this.keys()).map(t => t.symbol)
    const values = this.toArray().map(
      (v, i) => oracle.getPrice(keys[i]) * fromWei(v, tokens[i].decimals)
    )
    let result: string[] = []
    for (let i = 0; i < keys.length; i++) {
      result.push(keys[i] + ' => ' + values[i].toFixed(4))
    }
    return result.join(', ')
  }
}
